import Vue from 'vue'
import Dialog from './index.vue'

const DialogConstructor = Vue.extend(Dialog)

/**
 * 创建一个对话框
 *
 * @param options 配置选项
 * @returns 返回一个Promise对象，该对象在对话框关闭后解析
 */
function createDialog(options = {}) {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    const instance = new DialogConstructor({
      propsData: {
        ...options,
        visible: true,
      },
    })

    instance.$mount(container)

    const cleanUp = () => {
      instance.$destroy()
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
    }

    instance.$on('confirm', () => {
      resolve({ action: 'confirm' })
      cleanUp()
    })

    instance.$on('cancel', () => {
      resolve({ action: 'cancel' })
      cleanUp()
    })

    instance.$on('close', () => {
      resolve({ action: 'close' })
      cleanUp()
    })

    instance.$on('back', () => {
      resolve({ action: 'back' })
      cleanUp()
    })
  })
}

export default {
  install(Vue) {
    Vue.prototype.$dialog = createDialog
  },
}
